import React, {useState} from 'react';
import {Modal, ScrollView, Text, TouchableOpacity, View} from 'react-native';
import Feather from 'react-native-vector-icons/Feather';

import {styles} from './styles';
import {Colors} from '../../../../constants/Colors';
import SortModal from '../../../Home/components/SortModal/SortModal';
import {ISolicitation} from '../../../../types/Equipaments';

interface IModalFilter {
  visible: boolean;
  onRequestClose: () => void;
  item: ISolicitation;
  returnSort: (val: string) => void;
}

const EquipamentModal = ({
  visible,
  onRequestClose,
  item,
  returnSort,
}: IModalFilter) => {
  const verifyOrderType = {
    ZS03: 'Bonificação',
    ZS11: 'Troca',
    ZS43: 'Compra',
  };

  const [sort, setSort] = useState<boolean>(false);
  return (
    <Modal
      animationType="slide"
      transparent={true}
      visible={visible}
      onRequestClose={onRequestClose}>
      <View style={styles.containerModal}>
        <View style={styles.containerFilter}>
          <View style={styles.spaceHorizontal}>
            <TouchableOpacity onPress={onRequestClose}>
              <Feather
                name="x"
                size={32}
                color={Colors.lightGray}
                style={styles.iconX}
              />
            </TouchableOpacity>
            <View style={styles.containerConfirmed}>
              <Text style={styles.filterTitle}>Solicitação: {item?.MATNR}</Text>
              {/* <TouchableOpacity
                style={styles.filterButton}
                onPress={() => setSort(true)}>
                <Text style={styles.filterText}>Filtrar</Text>
                <Image source={Images.FiltersIcon} />
              </TouchableOpacity> */}
            </View>
          </View>
          <ScrollView style={styles.containerDrop}>
            <View style={styles.orderContainer}>
              <Text style={styles.orderText}>Documento:</Text>
              <Text style={[styles.orderText, styles.orderInfo]}>
                {item?.NRSOL}
              </Text>
            </View>
            <View style={styles.orderContainer}>
              <Text style={styles.orderText}>Tipo Equip.:</Text>
              <Text style={[styles.orderText, styles.orderInfo]}>
                {item?.TPEQP}
              </Text>
            </View>
            <View style={styles.orderContainer}>
              <Text style={styles.orderText}>Cód.Material:</Text>
              <Text style={[styles.orderText, styles.orderInfo]}>
                {item?.KUNNR}
              </Text>
            </View>
            <View
              style={
                (styles.orderContainer,
                {flexDirection: 'column', marginTop: 20})
              }>
              <Text style={styles.orderText}>Equipamento:</Text>
              <Text
                style={{
                  ...styles.orderText,
                  ...styles.orderInfo,
                }}>
                {item?.MAKTX}
              </Text>
            </View>
            <View style={styles.orderContainer}>
              <Text style={styles.orderText}>Status geral:</Text>
              <Text style={[styles.orderText, styles.orderInfo]}>
                {item?.STATUS}
              </Text>
            </View>
          </ScrollView>
          <View style={styles.containerButton}></View>
        </View>
      </View>
      <SortModal
        visible={sort}
        onRequestClose={() => setSort(false)}
        returnOrder={typeOrder => returnSort(typeOrder)}
      />
    </Modal>
  );
};

export default EquipamentModal;
